/**
 * H5 应用配置（修改后需重新编译或刷新 dev 服务）
 */

/**
 * 热点调试可视：true 时所有可点击热点显示半透明粉红底 + 虚线边框，便于开发对齐位置。
 * 生产环境务必保持 false。
 */
export const HOTSPOT_DEBUG_VISIBLE = false
